var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3A2951BB-6812-4E8C-A6E5-81A10F727D35") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "onboarding---desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D/education2",
    transform: "translate(-303.000000, -113.000000)",
    fill: "#1F2240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "progress-bar-+-button-2",
    transform: "translate(288.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "progress-bar-+-button",
    transform: "translate(0.000000, -7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-back",
    transform: "translate(15.000000, 50.750000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66358221,0.157599281 L9.34791222,0.474568748 C9.13871556,0.68465629 9.13871556,1.02529759 9.34791222,1.23542997 L17.3164033,9.23785543 L0.535714884,9.23785543 C0.239866339,9.23785543 0,9.47874326 0,9.7758517 L0,10.2241819 C0,10.5212904 0.239866339,10.7621782 0.535714884,10.7621782 L17.3164033,10.7621782 L9.34791222,18.7646037 C9.13871556,18.9746912 9.13871556,19.3153325 9.34791222,19.5254649 L9.66358221,19.8424343 C9.87277888,20.0525219 10.2119757,20.0525219 10.4211723,19.8424343 L19.8431025,10.380425 C20.0522992,10.1703375 20.0522992,9.82969616 19.8431025,9.61956379 L10.4211723,0.157599281 C10.2119757,-0.0525330938 9.87277888,-0.0525330938 9.66358221,0.157599281 Z",
    id: "Path-Copy",
    transform: "translate(10.000000, 10.000000) rotate(-180.000000) translate(-10.000000, -10.000000) "
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.aa175de428c45281b11804c9edee7760.svg";
export { ForwardRef as ReactComponent };